import React from 'react';
import { useState,useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Navigation from '../navigation/navigationVisiteur';
import Notification from '../messagerie_user/notification';
import PostAffichage from './postAffichage';
import NavArbitre from '../navigation/navArbitre';


const PostArbitre = () => {
  const Navigate = useNavigate();
  const [userData, setUserData] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [type, setType] = useState();
  const apiUrl = process.env.REACT_APP_API_URL;


  useEffect(() => {
    setIsLoading(true);
    const fetchData = async () => {
      try {
        const response = await axios.post(
          `${apiUrl}/verification/cookie`,
          {},
          {
            withCredentials: true 
          }
        );
        setUserData(response.data);
        setError(null);
        setIsLoading(false);
        if (response.data.user.type !== "arbitre") {
          Navigate('/connexion');
        }
        setType(response.data.user.type + "/tableau-de-bord" )
      } catch (error) {
        if (error.response) {   
          setError(error.response.data.message);
        } else {
       
          setError(true)
        }
        Navigate('/connexion')
        setIsLoading(false);

      }
    };

    fetchData(); 
  }, [Navigate, apiUrl]);
  
        if (isLoading) {
          return (
          <div className="centered-content">
            <img src="/img/logo.png" alt="Logo" className="centered-logo" />
            <br/>
            <span className="loader"></span>
          </div>
          
          );  
        }

    return (
<>   
      {error && 
      <>
        <Navigation/>
        <div id="alert-message" className="alert4" >
            <strong>ERROR ! </strong>{error} <span id="alert-text"></span>
        </div>
      </>  
        }
      {userData ? (
      <> 
          <NavArbitre userData={userData} nom='Post'/>
          <div className="main mess">
            <Notification userData={userData}/> 
            <div className='post1'>
                <div className="publi2">
                    <div className="nom1">
                        <img src='/img/bel.png' alt="logo de l'equipe"  />
                    </div>
                    <div className="post-header">
                        <h3><a href={`/arbitre/accueil`}>{userData.user.donnée.results[0].nom} {userData.user.donnée.results[0].prenom} {'('}Arbitre{')'}</a></h3>
                    </div>
                </div>
                </div>
                <br/>
                <PostAffichage userData={userData} type={type}/>
        </div>
        </>
              ) :(
                <>
                <Navigation/>        
              <div id="alert-message" className="alert" >
                  <strong>ERROR ! </strong>{error} <span id="alert-text"></span>
              </div></>
              )}
      </>
              
      );


}



export default PostArbitre;